<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal modal-two"
        role="dialog"
        id="myModal"
        aria-hidden='true'
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header
          class="modal-header"
          id="modalTitle"
        >
          <h3 class="modal-title">{{disclosure.disclosureHeader}}</h3>          
          <button
            id="closeModalBtn"
            type="button"
            class="btn-close"
            @click="close"
            aria-label="Close modal"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
              <path d="M16.5 2L1.5 17" stroke="#1C1F22" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.5 2L16.5 17" stroke="#1C1F22" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </header>

        <section
          class="modal-body"
          id="modalDescription"
        >
          <div v-html="disclosure.disclosureHeaderText"></div>  
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      disclosure: Object,
      isModalVisible: Boolean
    },
    methods: {
      close() {
        this.$emit('close');
        document.getElementById('showModalToolTip').focus();
      }
    },
    mounted() {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.$emit('close');
          document.getElementById('showModalToolTip').focus();
        }
      });

      const myModal = document.getElementById('myModal');
      myModal.addEventListener('keydown', (e) => {
        const isTabPressed = e.key === 'Tab';

        if (!isTabPressed) {
          return;
        }

        const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusableContent = myModal.querySelectorAll(focusableElements);
        const firstFocusableElement = focusableContent[0];
        const lastFocusableElement = focusableContent[focusableContent.length - 1];

        if (e.shiftKey) { 
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      }); 
    }
  };
</script>

<style lang="scss">

  .modal-backdrop[aria-hidden='true'] {
    display: none;
  }
  .btn-close {
    --bs-btn-close-bg: none !important;    
    width: 25px !important;
  }
  .modal-title {
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;    
  }
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    --bs-backdrop-bg: rgba(0, 0, 0, 0.3) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden !important;
    .modal-two {
      @include media-breakpoint-down(md) {
        border-radius: 5px;
      }
      position: absolute;
      background: #FFFFFF;
      box-shadow: 2px 2px 20px 1px;
      overflow-x: auto;
      display: flex !important;
      flex-direction: column;
      @include media-breakpoint-up(md) {
        max-width: 80%;
      }      
      max-width: 99%;
      max-height: 80%;
      top: 50%;
      left: 50%; 
      transform: translate(-50%, -50%); 
      overflow: hidden;      
    }
  }

  .modal-header,
  .modal-footer {
    padding: 24px !important;
    @include media-breakpoint-down(sm) {
      padding: 32px 16px 8px !important;
    }
    display: flex;
    gap: 1rem;
  }

  .modal-header {
    /* position: relative; */    
    border-bottom: 1px solid #eeeeee;
    @include media-breakpoint-down(sm) {
      border-bottom: none !important;
    }
    color: #4AAE9B;
    justify-content: space-between !important;
    // align-items: flex-start;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
  }

  .modal-body {
    /* position: relative; */
    padding: 24px !important;
    // margin: 16px;
    @include media-breakpoint-down(sm) {
      padding: 16px !important;
      // margin-bottom: 16px !important;
    }
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
      height: 24px;
    }
    &::-webkit-scrollbar-thumb {
      background: color-mix(in srgb, var(--dark) 50%, transparent);
      border-radius: 8px;
    }
  }

   

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
  .modal-title{
    font-size: 18px !important;
    font-weight: 700 !important;
  }
   .modal-body p {
     font-size: 16px !important;
  }
  
  @include media-breakpoint-down(sm) {
    .modal-body, .modal-title{
       font-size: 16px !important;       
    }
   }
</style>